import type { UserRoleString } from "@nlc/shared-types";

import { ProjectGroupEnum, USER_ROLES } from "@nlc/shared-types";

import { useRoleAccess } from "@/features/auth/permissions/useRoleAccess";

export function useGetAvailableTabs(): {
  id: ProjectGroupEnum;
  label: string;
}[] {
  const { hasRole } = useRoleAccess();

  if (hasRole([USER_ROLES.SUPER_ADMIN as UserRoleString])) {
    return [
      { id: ProjectGroupEnum.ACTIVE, label: "Active" },
      { id: ProjectGroupEnum.CANCELLED, label: "Cancelled" },
      { id: ProjectGroupEnum.ARCHIVED, label: "Archived" },
      {
        id: ProjectGroupEnum.KICKSTARTER,
        label: "Kickstarter",
      },
      {
        id: ProjectGroupEnum.PENDING_APPLICATIONS,
        label: "Pending Applications",
      },
      { id: ProjectGroupEnum.ALL, label: "All" },
    ];
  } else if (
    hasRole([
      USER_ROLES.TEAM_LEADER as UserRoleString,
      USER_ROLES.CUSTOMER_SUCCESS as UserRoleString,
    ])
  ) {
    return [
      { id: ProjectGroupEnum.ACTIVE, label: "Active" },
      { id: ProjectGroupEnum.CANCELLED, label: "Cancelled" },
      { id: ProjectGroupEnum.ARCHIVED, label: "Archived" },
      { id: ProjectGroupEnum.ALL, label: "All" },
    ];
  } else if (hasRole([USER_ROLES.DESIGNER as UserRoleString])) {
    return [
      { id: ProjectGroupEnum.ACTIVE, label: "Active" },
      { id: ProjectGroupEnum.ALL, label: "All" },
    ];
  } else {
    return [];
  }
}
